<template>
    <div class="report-cta-container">
      <div class="report-cta-card">
        <h3 class="report-cta-title">Explore Personalized Astrology Reports</h3>
        <p class="report-cta-text" style="text-align: justify;">
            Your <b>personalized Vedic astrology reports</b> are crafted using authentic principles to offer deep insights, clarity, and guidance on your life journey  
            - Now available at our <b>dedicated portal</b>.            
        </p>
        <a
          :href="reportUrl"
          target="_blank"
          rel="noopener"
          class="report-cta-button"
        >
          VedicAstrologyReport.com →
        </a>
      </div>
    </div>
  </template>
  

  <script>
  import HTTP from '@/http-axios';
  import ApiBaseUrl from '@/http-api-base-url'
  import { queryString, criteriaToken } from '@/util.js'
  
  export default {
      props: {
          criteria : {
              type: Object
          }
      },
      data() {
          return {
              reportUrl: "",
          }
      },
      created() {
          this.reportUrl =  'https://www.vedicastrologyreport.com?' + this.queryString(this.criteria);
      },
      mounted() {
      },
      methods: {
          queryString: function (obj) {
              return queryString(obj);
          },
      }
  }
  </script>

  <style scoped>

  .report-cta-container {
    display: flex;
    justify-content: center;
    padding: 20px;
  }
  
  .report-cta-card {
    max-width: 600px;
    width: 100%;
    margin: 30px auto;
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .report-cta-title {
    color: #087F8C;
    font-size: 20px;
    margin-bottom: 10px;
  }
  
  .report-cta-text {
    font-size: 15px;
    line-height: 1.6;
    color: #333;
    margin-bottom: 16px;
  }
  
  .report-cta-button {
    display: inline-block;
    background-color: #087F8C;
    color: white;
    padding: 10px 18px;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.3s ease;
  }
  
  .report-cta-button:hover {
    background-color: #218838;
  }
  
  @media (max-width: 600px) {
    .report-cta-card {
      padding: 16px;
    }
  
    .report-cta-title {
      font-size: 18px;
    }
  
    .report-cta-text {
      font-size: 14px;
    }
  
    .report-cta-button {
      padding: 8px 16px;
    }
  }
  </style>
  